import '.d{display:flex;}.ssr-plugin'
import '.at{justify-content:center;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.aq{aspect-ratio:1/1;}.ssr-plugin'
import '.au{border:none;}.ssr-plugin'
import '.av{background:var(--gray-100);}.ssr-plugin'
import '.a5{font-weight:400;}.ssr-plugin'
import '.ar{flex-shrink:0;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'

export interface CloseButtonProps {
  size?: Size
  onClick: () => void
}

type Size = 'small' | 'medium' | 'large'
const sizeStyle: Record<Size, Style> = {
  large: {
    height: '2.5rem',
    width: '2.5rem',
    padding: '0.3125rem 0.375rem 0.375rem 0.3125rem',
    borderRadius: '0.625rem',
    fontSize: '1.5rem',
  },
  medium: {
    height: '2rem',
    width: '2rem',
    borderRadius: '0.5rem',
    fontSize: '1.4375rem',
  },
  small: {
    height: '1.5rem',
    width: '1.5rem',
    borderRadius: '0.375rem',
    fontSize: '1.125rem',
  },
}

export const CloseButton = ({ size = 'large', onClick }: CloseButtonProps) => {
  return (
    <styled.button className="d at t aq au av a5 ar a1"
      onClick={onClick}
      style={{
        ...sizeStyle[size],
      }}
    >
      {<FontAwesomeIcon icon={faXmark} />}
    </styled.button>
  )
}
